/**
 * RA Documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { LookingForProjectDTO } from './lookingForProjectDTO';
import { PageableObject } from './pageableObject';
import { SortObject } from './sortObject';


export interface PageLookingForProjectDTO { 
    totalElements?: number;
    totalPages?: number;
    size?: number;
    content?: Array<LookingForProjectDTO>;
    number?: number;
    sort?: SortObject;
    numberOfElements?: number;
    first?: boolean;
    last?: boolean;
    pageable?: PageableObject;
    empty?: boolean;
}

